<template>
  <div
    class="wrapper"
    style="
      padding-top: 0px;
      margin: 0px;
      width: 100%;
      height: 100%;
      background-color: #f6f6f6;
      max-width: 100%;
    "
  >
    <header class="show_header">
      <div>
        <button class="btn-sidebar" @click="$router.go(-1)">
          <img src="@/assets/img/arrow_back.svg" />
        </button>
      </div>

      <div class="header_title">
        <h3 class="upper title">ShowTimes</h3>
      </div>
      <div>
        <img
          src="@/assets/img/camera.svg"
          width="100%"
          class=""
          @click="scannerSection()"
        />
      </div>
      <div class="">
        <button class="btn-logout" @click="onLogout()">
          Logout
        </button>
      </div>
    </header>
    <!---Time & Date---->
    <section>
      <h3 class="upper date">{{ ShowDate }}</h3>
    </section>

    <!--Shedule 1--->

    <section
      class="schedule_main"
      v-for="(schedule, schIndex) in scheduleList"
      :key="schIndex"
    >
      <h3 class="title">
        {{ schedule.original_movie_title }}
        <span style="font-size: 12px; color: #818183">
          ({{
            moment(schedule.mrrdr_release_date, "YYYY-MM-DD").format("YYYY")
          }})</span
        >
      </h3>
      <div class="d-flex" style="gap: 10px; margin-top: 5px">
        <div class="rating">{{ schedule.rating }}</div>
        <div class="rating">{{ schedule.runtime }} min</div>
      </div>

      <!---Screen 1--->
      <section
        class="screening_section"
        v-for="(screen, screenIndex) in schedule.screens"
        :key="screenIndex"
      >
        <div
          class="d-flex align-items-center justify-content-start"
          style="gap: 10px; margin: 14px 0px"
        >
          <h2 class="screen_title">{{ screen.screen_name }}</h2>
          <button class="language">{{ screen.version_full_name }}</button>
        </div>

        <div class="btn-section">
          <template v-for="showArray in screen.shows">
            <div
              :key="showIndex"
              class=""
              v-for="(show, showIndex) in showArray.shows"
            >
              <div class="show_btn" v-if="show.mf_name.toLowerCase() !== '2d'">
                <div class="main_btn_sec">
                  <p>{{ show.ss_start_show_time }}</p>
                  <button
                    v-if="show.mf_name.toLowerCase() == '4dx'"
                    class="dx_btn"
                  >
                    <img src="@/assets/img/4dx-new.svg" width="20px" />
                  </button>
                  <button v-else class="dx_btn">{{ show.mf_name }}</button>
                </div>
              </div>
              <button class="sch_btn" v-else>
                {{ show.ss_start_show_time }}
              </button>
            </div>
          </template>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import BookingService from "@/services/BookingService";
import moment from "moment";
export default {
  name: "hello",
  data() {
    return {
      bookingCode: "",
      scheduleList: [],
      cinema_id: null,
      ShowDate: moment().format("DD.MMM.YYYY"),
    };
  },
  beforeMount() {
    this.cinema_id = window.localStorage.getItem("USERCINEINFO");
    this.getAllShowTimes();
  },
  methods: {
    moment,
    goToShow() {
      this.$router.push({
        name: "showtime",
        path: "/showtime",
      });
    },
    scannerSection() {
      this.$router.push({
        name: "qrCode",
        path: "/qrCode",
      });
    },
    onLogout() {
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.removeItem("USERCINEINFO");
      window.localStorage.clear();
      this.$cookie.delete("BRHSID");
      this.$router.push({
        name: "login",
      });
      return window.caches.keys();
    },
    onSubmitBookingCode() {
      if (this.bookingCode) {
        this.$router.push({
          name: "details",
          query: { qrcode: this.bookingCode },
        });
      } else {
        this.$toasted.show("Please Enter Booking Code");
      }
    },
    getAllShowTimes() {
      let loader = this.$loading.show();
      let payload = {
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        cinema_id: this.cinema_id || null,
        operator: "qrcode",
      };
      BookingService.GetShowTimesList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Dates && data.Dates.length > 0) {
            this.ShowDate = moment(data.Dates[0]).format("DD.MMM.YYYY");
          } else {
            this.ShowDate = moment().format("DD.MMM.YYYY");
          }
          if (data && data.status && data.Records.length > 0) {
            this.scheduleList = data.Records.filter((x) => x.showCount > 0);
          } else {
            this.$toasted.show(data.message || "No Records Found");
          }
        })
        .catch((err) => {
          console.log("Error: Something Went Wrong", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    goToScan() {
      this.$router.push({
        name: "qrCode",
        path: "/qrCode",
      });
    },
  },
};
</script>
<style>
.show_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f6f6f6;
  padding: 15px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));
}
h2,
h3 {
  margin-bottom: 0px;
}
.title {
  font-size: 16px;
  color: black;
  font-weight: 700;
}
.upper {
  text-transform: uppercase;
}
.date {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  color: #818183;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.6px;
}
.schedule_main {
  background-color: white;
  padding: 15px;
}
.rating {
  color: black;
  background-color: #f6f6f6;
  padding: 5px;
  font-size: 10px;
  font-weight: bold;
}
.screen_title {
  color: #032d6e;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
}
.screening_section {
  margin: 10px 0px;
}
.language {
  background-color: #4fadb5;
  color: white;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 13px;
  border: 1px solid #4fadb5;
  border-radius: 2px;
}
.btn-section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.sch_btn {
  background-color: #f7f7f7;
  border: 0.75px solid #4fadb5;
  border-radius: 4.50004px;
  color: black;
  font-size: 14px;
  font-weight: 600;
  padding: 3px 15px;
}
.show_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f7;
  border: 0.75px solid #4fadb5;
  border-radius: 4.50004px;
  font-size: 14px;
  font-weight: 600;
  padding: 3px 15px;
}
.show_btn p {
  margin-bottom: 0px;
}

.main_btn_sec {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.main_btn_sec button {
  position: absolute;
  margin-top: 27px;
  color: white;
  font-weight: 700;
}
.dx_btn {
  background-color: #4fadb5;
  border: none;
  border-radius: 2px;
  font-size: 8px;
}

.schedule_main:not(:first-child) {
  margin-top: 10px;
}
.btn-logout {
  background-color: #032d6e;
  color: #fff;
  border-radius: 2px;
  /* position: absolute;
  right: 10px; */
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ShowTime.vue